import { Component, OnInit,Optional,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Console, error } from 'console';
import { data } from 'jquery';
import {CommentsHistoryModel} from 'src/app/views/Audit/project-overview/models/comments-history.model';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-comments-history-dialog',
  templateUrl: './comments-history-dialog.component.html',
  styleUrls: ['./comments-history-dialog.component.css']
})
export class CommentsHistoryDialogComponent implements OnInit {

  showAddCommentTextArea:boolean = false;
  auditId : number = 0;
  statusId : number = 0;
  commentHistoryList : Array<CommentsHistoryModel> = [];
  commentsEntered : string = "";

  constructor(
    @Optional() public dialogRef: MatDialogRef<CommentsHistoryDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public dialogInfo: any,
        private auditOverviewService: AuditOverviewService,
        private toasterService: ToastrService
  ){
    this.auditId = dialogInfo.auditId
    this.statusId = dialogInfo.statusId
  }

  getCommentsHistory(){
    this.auditOverviewService.getAllCommentsHistory(this.auditId).subscribe(
      (responseData:CommentsHistoryModel[])=>{
        let list = responseData
        this.commentHistoryList = responseData
      },
      (error)=> {
        this.toasterService.error(error);
      } );
  }
  ngOnInit() {
    this.getCommentsHistory()
  }
  
  onAddCommentClick(){
    this.showAddCommentTextArea = true;
  }

  closeDialog(isClose : boolean) {
    if (isClose) {
       this.dialogRef.close();
    }
  }

  submitComments(){
    this.auditOverviewService
    .addCommentForStage(this.auditId,this.statusId,this.commentsEntered).subscribe(
      (response)=> {
        this.commentsEntered = "";
        this.closeDialog(true)
      },
      (error)=> {
        this.toasterService.error(error);
      }
    )
  }
}